import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as taskActivateFormCreateReduceObject } from '../../../common/reducers/taskActivateForm';
import { createReduceObject as taskStopFormCreateReduceObject } from '../../../common/reducers/taskStopForm';
import { createReduceObject as taskRemoveFormCreateReduceObject } from '../../../common/reducers/taskRemoveForm';
import { createReduceObject as taskToggleChosenMarkFormCreateReduceObject } from '../../../common/reducers/taskToggleChosenMarkForm';
import { createReduceObject as taskToggleHideMarkFormCreateReduceObject } from '../../../common/reducers/taskToggleHideMarkForm';

import { createReduceObject as execCreateFormCreateReduceObject } from '../../../common/reducers/execCreateForm';
import { createReduceObject as execCommentFormCreateReduceObject } from '../../../common/reducers/execCommentForm';
import { createReduceObject as execConfirmFormCreateReduceObject } from '../../../common/reducers/execConfirmForm';
import { createReduceObject as execDisputeFormCreateReduceObject } from '../../../common/reducers/execDisputeForm';
import { createReduceObject as execReportFormCreateReduceObject } from '../../../common/reducers/execReportForm';
import { createReduceObject as execRefuseFormCreateReduceObject } from '../../../common/reducers/execRefuseForm';
import { createReduceObject as execRemakeFormCreateReduceObject } from '../../../common/reducers/execRemakeForm';
import { createReduceObject as execAnswerConfirmFormCreateReduceObject } from '../../../common/reducers/execAnswerConfirmForm';
import { createReduceObject as execAddMaterialsReducerCreateReduceObject } from '../../../common/reducers/execAddMaterialsReducer';
import { createReduceObject as execDeleteMaterialsReducerCreateReduceObject } from '../../../common/reducers/execDeleteMaterialsReducer';

import taskActiveFormSaga from './sagas/taskActiveFormSaga';
import taskStopFormSaga from './sagas/taskStopFormSaga';
import taskRemoveFormSaga from './sagas/taskRemoveFormSaga';
import taskToggleChosenMarkFormSaga from './sagas/taskToggleChosenMarkFormSaga';
import taskToggleHideMarkFormSaga from './sagas/taskToggleHideMarkFormSaga';
import execCreateFormSaga from './sagas/execCreateFormSaga';

import execCommentFormSaga from './sagas/execCommentFormSaga';
import execConfirmFormSaga from './sagas/execConfirmFormSaga';
import execDisputeFormSaga from './sagas/execDisputeFormSaga';
import execReportFormSaga from './sagas/execReportFormSaga';
import execRefuseFormSaga from './sagas/execRefuseFormSaga';
import execRemakeFormSaga from './sagas/execRemakeFormSaga';
import execAnswerConfirmFormSaga from './sagas/execAnswerConfirmFormSaga';
import execAddMaterialsFormSaga from './sagas/execAddMaterialsFormSaga';
import execDeleteMaterialsFormSaga from './sagas/execDeleteMaterialsFormSaga';

export default [
  // Tasks
  ...createCombineMapItem(
    'taskActivateForm',
    taskActivateFormCreateReduceObject,
    [taskActiveFormSaga]
  ),
  ...createCombineMapItem('taskStopForm', taskStopFormCreateReduceObject, [
    taskStopFormSaga
  ]),
  ...createCombineMapItem('taskRemoveForm', taskRemoveFormCreateReduceObject, [
    taskRemoveFormSaga
  ]),
  ...createCombineMapItem(
    'taskToggleChosenMarkForm',
    taskToggleChosenMarkFormCreateReduceObject,
    [taskToggleChosenMarkFormSaga]
  ),
  ...createCombineMapItem(
    'taskToggleHideMarkForm',
    taskToggleHideMarkFormCreateReduceObject,
    [taskToggleHideMarkFormSaga]
  ),
  // Execs
  ...createCombineMapItem('execCreateForm', execCreateFormCreateReduceObject, [
    execCreateFormSaga
  ]),
  ...createCombineMapItem(
    'execCommentForm',
    execCommentFormCreateReduceObject,
    [execCommentFormSaga]
  ),
  ...createCombineMapItem(
    'execConfirmForm',
    execConfirmFormCreateReduceObject,
    [execConfirmFormSaga]
  ),
  ...createCombineMapItem(
    'execDisputeForm',
    execDisputeFormCreateReduceObject,
    [execDisputeFormSaga]
  ),
  ...createCombineMapItem('execReportForm', execReportFormCreateReduceObject, [
    execReportFormSaga
  ]),
  ...createCombineMapItem('execRefuseForm', execRefuseFormCreateReduceObject, [
    execRefuseFormSaga
  ]),
  ...createCombineMapItem('execRemakeForm', execRemakeFormCreateReduceObject, [
    execRemakeFormSaga
  ]),
  ...createCombineMapItem(
    'execAnswerConfirm',
    execAnswerConfirmFormCreateReduceObject,
    [execAnswerConfirmFormSaga]
  ),
  ...createCombineMapItem(
    'execAddMaterials',
    execAddMaterialsReducerCreateReduceObject,
    [execAddMaterialsFormSaga]
  ),
  ...createCombineMapItem(
    'execDeleteMaterials',
    execDeleteMaterialsReducerCreateReduceObject,
    [execDeleteMaterialsFormSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/forms/reducersMap.js